export const createRole = {
  pageSize: 10,
  merchantPortalUrlFallback: 'https://merchants.thyaga.lk/',
  passwordMinLength: 6,
  mobileRegex: /^\+94\d{9}$/,
  tag: 'adminUsers',

  titles: {
    createUser: 'Create Admin User',
    createRole: 'Create Role',
    userCreated: 'User Created',
    subMerchantDetails: 'Sub Merchant Details',
  },

  labels: {
    url: 'URL',
    email: 'Email',
    password: 'Password',
    mobile: 'Mobile Number',
    role: 'Role',
    merchant: 'Merchant',
    merchants: 'Merchants',
    subMerchant: 'Sub Merchant',
  },

  placeholders: {
    email: 'Enter email',
    password: 'Enter password',
    mobile: 'Mobile Number',
    selectRole: 'Select a role',
    selectMerchant: 'Search and select a merchant',
    selectMerchants: 'Search and select merchants',
    selectSubMerchant: 'Search and select a sub merchant',
    searchByEmail: 'Search by email',
    searchByMerchantId: 'Search by merchant ID',
  },

  buttonText: {
    createRole: 'Create Role',
    cancel: 'Cancel',
    create: 'Create',
    creating: 'Creating...',
    done: 'Done',
    copyAll: 'Copy All',
    search: 'Search',
    clear: 'Clear',
  },

  messages: {
    emailInvalid: 'Enter a valid email',
    emailRequired: 'Email cannot be empty',
    passwordTooShort: 'Password must be at least 6 characters',
    passwordRequired: 'Password cannot be empty',
    mobileInvalid: 'Enter a valid mobile number (+94 followed by 9 digits)',
    mobileRequired: 'Mobile number cannot be empty',
    roleRequired: 'Role cannot be empty',
    merchantsRequired: 'Select at least one merchant',
    subMerchantRequired: 'Select a sub merchant',
    merchantsLoadFailed: 'Failed to load merchants',
    subMerchantsLoadFailed: 'Failed to load sub merchants',
    createUserFailed: 'Failed to create user',
    copiedToClipboard: 'Copied to clipboard',
    subMerchantNote:
      '*If selected, user can only gain access as selected sub merchant administrator',
    shareCredentialsNote: 'Share these credentials with the new user.',
    oneTimeViewWarning:
      'This is a one time view. Copy and keep it in a safe place.',
    fetchAdministratorsFailed: 'Oops, something went wrong. Please try again',
  },

  tableColumns: ['Email', 'Role', 'Mobile'],
  notFoundMessage: 'No data',
};
